import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import AllhomesPropertyOfTheWeek from '@domain-group/fe-co-allhomes-property-of-the-week/lib/js/allhomes-property-of-the-week';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import gaHelper from '@domain-group/fe-allhomes-library/lib/utils/ga-helper';
import * as styles from './allhomes-listing-no-search-results.style';
import OldPropertyAlertButton from './old-property-alert-button';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingNoSearchResults = props => {
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  return ___EmotionJSX("section", {
    css: styles.content
  }, ___EmotionJSX("div", {
    css: styles.contents
  }, ___EmotionJSX("img", {
    src: "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-search-results/static/no-results_ab1f0f17.png",
    css: styles.image,
    alt: "No properties match your search right now"
  }), ___EmotionJSX("div", {
    css: styles.text
  }, "No properties match your search right now. You could:"), ___EmotionJSX("ul", {
    css: styles.actions
  }, ___EmotionJSX("li", null, "Change your search locations,", props.isDefaultSearch && ' or'), ___EmotionJSX("li", null, ___EmotionJSX(OldPropertyAlertButton, {
    buttonLabel: "Create a property alert",
    onPropertyAlertClick: props.onPropertyAlertClick,
    type: "link",
    targetUrl: getAbsoluteUrl('/property-alerts')
  }), ' ', "for this search", props.isDefaultSearch || ', or'), props.isDefaultSearch || ___EmotionJSX("li", null, ___EmotionJSX("button", {
    type: "button",
    onClick: props.onClearFilter,
    css: styles.button
  }, "Clear all filters"), ' ', "and start again."))), !isEmpty(props.propertiesOfTheWeek) && ___EmotionJSX("div", {
    css: styles.powWrapper
  }, ___EmotionJSX(AllhomesPropertyOfTheWeek, {
    listings: props.propertiesOfTheWeek,
    onClick: (card, index) => {
      gaHelper.interactionEvent("Property of the Week - Position ".concat(index + 1));
    }
  })));
};
AllhomesListingNoSearchResults.propTypes = {
  propertiesOfTheWeek: PropTypes.arrayOf(PropTypes.shape({})),
  isDefaultSearch: PropTypes.bool,
  onClearFilter: PropTypes.func,
  onPropertyAlertClick: PropTypes.func
};
AllhomesListingNoSearchResults.defaultProps = {
  onClearFilter: () => {},
  propertiesOfTheWeek: [],
  isDefaultSearch: false,
  onPropertyAlertClick: () => {}
};
export default AllhomesListingNoSearchResults;